























































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import Sorting from '@morpheus/utils/admin-vue/mixins/sorting'
import UsersList from '../components/UsersList.vue'
import {
  fetchUsersList,
  deleteUserById,
  banUserById
} from '../services/users-client'
import { UsersListData, UsersListItemData } from '../types'
import capabilities from '../../config.json'

export default mixins(Pagination, Sorting).extend({
  name: 'Users',
  components: {
    UsersList
  },
  mixins: [Pagination, Sorting],
  data () {
    return {
      isLoading: true,
      search: {
        query: ''
      },
      headers: [
        { text: '', value: '_id', sortable: false },
        { text: 'Username', value: 'username', sortable: false },
        { text: 'Enabled', value: 'banned', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: 'Actions', value: '_id', align: 'center', sortable: false }
      ],
      itemsList: [],
      searchParams: '',
      sortConfig: capabilities.sorting.usersList,
      sortableColumns: Object.keys(capabilities.sorting.usersList) || []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchUsersList(`?limit=${this.rowsPerPage}&offset=${this.paginationOffset}${this.searchParams}${this.sortParams}`)
        .then(({ items, total }: UsersListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: UsersListItemData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.$store.commit('global/setLoading', false)
          this.isLoading = false
        })
    },
    onDeleteUser (id: string) {
      this.isLoading = true
      deleteUserById(id)
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully deleted user!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onBanUser (id: string, status: boolean, reason:string) {
      this.isLoading = true
      banUserById(id, {
        status: status,
        reason: reason
      })
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully changed user status!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    searchUser () {
      let params = ''
      Object.entries(this.search).forEach(([key, value]) => {
        if (value !== '') {
          params += `&${key}=${encodeURIComponent(value)}`
        }
      })

      this.searchParams = params
      this.fetchItems()
    },
    resetSearch () {
      this.search.query = ''
      this.searchUser()
    }
  }
})
